import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/csr';
import SEOlinksA from '@/components/SEOlinksA';
import CorporateSocialResponsibility_PC from '@/components/CorporateSocialResponsibility';
import CorporateSocialResponsibility_H5 from '@/componentsH5/CorporateSocialResponsibility';
import { useLang } from '@/app/utils/useLang';

// CSR NA版本
export default function CorporateSocialResponsibility({ SEO }: any) {
    const { useRouter, useEffect, isMobile, useState } = useGlobal();
    const [PageComponent, setPageComponent] = useState(<></>);
    const { t } = useLang('corporatesocialresponsibility');
    const router = useRouter();
    const { locale } = router;
    const Com = isMobile ? <CorporateSocialResponsibility_H5 /> : <CorporateSocialResponsibility_PC />;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!['us', 'ca', 'de', 'fr', 'it', 'es', 'cn', 'za', 'au', 'eu', 'uk', 'jp', 'br', 'kr', 'mx', 'ph'].includes(locale)) {
            router.push('/404');
        } else {
            setPageComponent(Com);
        }
    }, []);

    return (
        <PageLayout isNoFixed>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            {PageComponent}
        </PageLayout>
    );
}
